<template>
  <div class="add-technologyBom">
    <el-form :model="addForm" :rules="rules" ref="addForm">
      <el-card class="table_searchbar">
        <el-row>
          <el-col :span="24" style="text-align: center; margin-bottom: 20px">
            <span class="el-dialog__title">编辑工艺BOM</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="W ? 5 : 5">
            <span class="title">工艺编码：</span>
            <el-form-item
              prop="technologyCode"
              :rules="rules.technologyCode"
              style="display: inline-block"
            >
              <el-input
                :maxlength="50"
                v-model="addForm.technologyCode"
                :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }"
                placeholder="工艺编码"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="W ? 5 : 5">
            <div>
              <span class="title">物料编码：</span>
              <el-form-item
                prop="materialId"
                :rules="rules.materialId"
                style="display: inline-block"
              >
                <el-select
                  filterable
                  v-model="addForm.materialId"
                  :loading="loading"
                  @change="materialSelect"
                  @visible-change="materialSelectClose"
                  :remote-method="
                    (query) => {
                      this.remoteMethod('', query);
                    }
                  "
                  remote
                  placeholder="物料编码"
                  clearable
                  :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }"
                >
                  <el-option
                    v-for="item in materialList"
                    :key="item.id"
                    :label="item.materialCode"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="W ? 5 : 5">
            <div>
              <span class="title">物料名称：</span>
              <el-select
                filterable
                v-model="addForm.materialId"
                :loading="loading"
                @change="materialSelect"
                @visible-change="materialSelectClose"
                :remote-method="
                  (query) => {
                    this.remoteMethod(query);
                  }
                "
                remote
                placeholder="物料名称"
                clearable
                :style="W ? { 'max-width': '160px' } : { 'max-width': '95px' }"
              >
                <el-option
                  v-for="item in materialList"
                  :key="item.id"
                  :label="item.materialName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="W ? 8 : 8">
            <div>
              <span class="title">规格型号：</span>
              <el-select
                filterable
                v-model="addForm.materialId"
                :loading="loading"
                @change="materialSelect"
                @visible-change="materialSelectClose"
                :remote-method="
                  (query) => {
                    this.remoteMethod('', '', null, query);
                  }
                "
                remote
                placeholder="规格型号"
                clearable
                :style="W ? { width: '320px' } : { 'max-width': '160px' }"
              >
                <el-option
                  v-for="item in materialList"
                  :key="item.id"
                  :label="item.specification"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>

        <el-row style="margin: 10px 0 10px 0">
          <el-col :span="W ? 5 : 5">
            <div>
              <span class="title">物料类型：</span>
              <el-select
                disabled
                filterable
                v-model="addForm.type"
                @change="typeSelect"
                placeholder="物料"
                clearable
                :style="W ? { 'max-width': '160px' } : { 'max-width': '95px' }"
              >
                <el-option :key="0" label="产品" :value="0"></el-option>
                <el-option :key="1" label="零件" :value="1"></el-option>
                <el-option :key="2" label="原材料" :value="2"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="W ? 5 : 5">
            <div>
              <span class="title">工艺路线：</span>
              <el-form-item
                prop="routeName"
                :rules="rules.routeName"
                style="display: inline-block"
              >
                <el-input
                  :maxlength="50"
                  v-model="addForm.routeName"
                  :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }"
                  placeholder="工艺路线"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="W ? 5 : 5">
            <div>
              <span class="title">机组名称：</span>
              <el-select
                filterable
                multiple
                v-model="addForm.factoryModelNames"
                collapse-tags
                placeholder="机组名称"
                clearable
                :style="W ? { 'max-width': '160px' } : { 'max-width': '95px' }"
              >
                <el-option
                  v-for="item in factoryModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="W ? 9 : 9">
            <span class="title" style="width: 98px; margin-left: -12px"
              >工艺模板名称：</span
            >
            <el-select
              @visible-change="templateFocus"
              v-model="addForm.templateId"
              filterable
              ref="mySelect"
              clearable
              @change="templateChange"
              placeholder="工艺模板名称"
              :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }"
            >
              <el-option
                v-for="item in templateOptions"
                :key="item.technologyTemplateId"
                :label="item.technologyTemplateName"
                :value="item.technologyTemplateId"
              ></el-option>
            </el-select>
            <el-checkbox style="margin: 0 0 0 30px" v-model="addForm.isTestTech"
              >是否试制工艺</el-checkbox
            >
          </el-col>
        </el-row>

        <el-table
          :data="addForm.procedureList"
          :maxHeight="356"
          style="width: 100%"
          @row-click="handdle"
          :row-style="rowStyle"
          :row-class-name="rowClass"
        >
          <el-table-column label="操作" min-width="50px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block">
                <i
                  class="el-icon-delete"
                  v-if="procedureList.length > 1"
                  style="color: red; cursor: pointer; font-size: 16px"
                  @click="delLists(scope.$index)"
                ></i>
                <i
                  @click="addLists(scope.$index)"
                  class="el-icon-circle-plus-outline"
                  style="
                    color: #007acc;
                    cursor: pointer;
                    font-size: 16px;
                    font-weight: 700;
                  "
                ></i>
                <i
                  class="el-icon-bottom"
                  @click="downLists(scope.$index)"
                  v-if="scope.$index != procedureList.length - 1"
                  style="
                    color: #007acc;
                    cursor: pointer;
                    font-size: 16px;
                    font-weight: 700;
                  "
                ></i>
                <i
                  class="el-icon-top"
                  @click="topLists(scope.$index)"
                  v-if="scope.$index != 0"
                  style="
                    color: #007acc;
                    cursor: pointer;
                    font-size: 16px;
                    font-weight: 700;
                  "
                ></i>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="序号" min-width="50px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`procedureList[${scope.$index}].procedureIndex`"
                :rules="rules.procedureIndex"
                style="display: inline-block"
              >
                <el-input :maxlength="8" v-model="scope.row.procedureIndex"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="工序编码" min-width="80px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block">
                <el-select
                  v-model="scope.row.procedureCode"
                  @visible-change="
                    ($event) => {
                      if (!$event) {
                        loadProcedureListByProcedure('', '', scope.row);
                      }
                    }
                  "
                  @change="procedureSelectChange(scope.row)"
                  filterable
                  clearable
                  :loading="loading"
                  remote
                  :remote-method="
                    (query) => loadProcedureListByProcedure(query, '', scope.row)
                  "
                >
                  <el-option
                    v-for="(item, index) in scope.row.procedureMapFactoryModelList"
                    :key="index"
                    :label="item.procedureCode"
                    :value="item.procedureCode"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="工序名称" min-width="80px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`procedureList[${scope.$index}].procedureName`"
                :rules="rules.procedureName"
                style="display: inline-block"
              >
                <el-select
                  v-model="scope.row.procedureCode"
                  @visible-change="
                    ($event) => {
                      if (!$event) {
                        loadProcedureListByProcedure('', '', scope.row);
                      }
                    }
                  "
                  @change="procedureSelectChange(scope.row)"
                  filterable
                  clearable
                  :loading="loading"
                  remote
                  :remote-method="
                    (query) => loadProcedureListByProcedure('', query, scope.row)
                  "
                >
                  <el-option
                    v-for="(item, index) in scope.row.procedureMapFactoryModelList"
                    :key="index"
                    :label="item.procedureName"
                    :value="item.procedureCode"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="机组编码" min-width="100px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block">
                <el-input disabled v-model="scope.row.factoryModelCode"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="机组名称" min-width="100px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block">
                <el-input disabled v-model="scope.row.factoryModelName"></el-input>
              </el-form-item>
            </template>
          </el-table-column>

          <!-- <el-table-column label="设备类型" min-width="100px">
                        <template slot-scope="scope">
                            <el-form-item  style="display: inline-block;">
                                <el-select v-model="scope.row.deviceTypeId" filterable >
                                    <el-option v-for="item in deviceTypeOptions" :key="item.id" :label="item.deviceType" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column> -->

          <el-table-column label="默认工价(元)" min-width="80px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`procedureList[${scope.$index}].defaultSalary`"
                :rules="rules.defaultSalary"
                style="display: inline-block"
              >
                <el-input :maxlength="8" v-model="scope.row.defaultSalary"></el-input>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column label="是否报工" min-width="80px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block">
                <el-checkbox v-model="scope.row.isNeedReport"></el-checkbox>
              </el-form-item>
            </template>
          </el-table-column>
          <!-- <el-table-column label="是否追溯扫码" min-width="80px">
                        <template slot-scope="scope">
                            <el-form-item  style="display: inline-block;">
                                <el-checkbox v-model="scope.row.needScanCode"></el-checkbox>
                            </el-form-item>
                        </template>
                    </el-table-column> -->
        </el-table>
      </el-card>
      <el-card class="table-card">
        <el-tabs
          type="border-card"
          class="eltabs"
          v-model="activeName"
          @tab-click="itemChange"
        >
          <el-tab-pane label="SOP文档" name="sopDocList">
            <el-table :data="procedureList[index].sopDocList" :maxHeight="162">
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <i
                    class="el-icon-delete"
                    v-if="procedureList[index].sopDocList.length > 1"
                    style="color: red; cursor: pointer; font-size: 16px"
                    @click="delSopLists(scope.$index)"
                  ></i>
                  <i
                    @click="addSopLists(scope.$index)"
                    v-if="procedureList[index].sopDocList.length == scope.$index + 1"
                    class="el-icon-circle-plus-outline"
                    style="
                      color: #007acc;
                      cursor: pointer;
                      font-size: 16px;
                      font-weight: 700;
                    "
                  ></i>
                </template>
              </el-table-column>
              <el-table-column label="序号" type="index"></el-table-column>
              <el-table-column label="SOP名称" width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.fileId != null">
                    <div style="width: 80px; height: 70px; padding-top: 10px">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.fileName"
                        placement="bottom-end"
                      >
                        <div
                          class="file-icon-container"
                          :style="{ backgroundImage: `url(${scope.row.filePath})` }"
                          @click="showFile(scope.row.fileUrl)"
                        >
                          <div
                            class="file-delete"
                            @click.stop="deleteFile(scope, 1)"
                          ></div>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                  <div
                    v-else
                    style="
                      width: 40px;
                      height: 40px;
                      border: dotted #409eff 1px;
                      text-align: center;
                    "
                    @click="selectUploadFile(scope, 0)"
                  >
                    <i
                      class="el-icon-plus"
                      style="width: 40px; height: 40px; margin-top: 12px"
                    ></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="SOP文档名称" prop="">
                <template slot-scope="scope">
                  <span v-if="scope.row.fileId != null">{{ scope.row.fileName }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="自定义参数" name="technologyParameterInfoList">
            <br /><br />
            <el-select
              v-model="paramsTemplateId"
              placeholder="工艺参数模板"
              clearable
              filterable
              @change="(val) => changeParamsTemplate(val, index)"
            >
              <el-option
                v-for="item in paramsTemplateList"
                :key="item.id"
                :label="item.modelName"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <br /><br />
            <el-table
              :data="procedureList[index].technologyParameterInfoList"
              :maxHeight="162"
            >
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <i
                    class="el-icon-delete"
                    v-if="procedureList[index].technologyParameterInfoList.length > 1"
                    style="color: red; cursor: pointer; font-size: 16px"
                    @click="delParameterList(scope.$index)"
                  ></i>
                  <i
                    @click="addParameterList(scope.$index)"
                    v-if="
                      procedureList[index].technologyParameterInfoList.length ==
                      scope.$index + 1
                    "
                    class="el-icon-circle-plus-outline"
                    style="
                      color: #007acc;
                      cursor: pointer;
                      font-size: 16px;
                      font-weight: 700;
                    "
                  ></i>
                </template>
              </el-table-column>

              <el-table-column label="序号" type="index"></el-table-column>

              <el-table-column label="机组">
                <template slot-scope="scope">
                  <el-select
                    filterable
                    v-model="scope.row.factoryModelId"
                    collapse-tags
                    placeholder="机组名称"
                    clearable
                  >
                    <el-option
                      v-for="item in factoryModelList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="参数名称">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    maxlength="16"
                    v-model="scope.row.parameterName"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="参数值">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    maxlength="16"
                    v-model="scope.row.parameterValue"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="下限值">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    maxlength="16"
                    v-model="scope.row.lowerLimit"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="上限值">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    maxlength="16"
                    v-model="scope.row.upperLimit"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="描述信息">
                <template slot-scope="scope">
                  <el-input
                    :maxlength="100"
                    size="small"
                    v-model="scope.row.description"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>

        <el-row style="margin-top: 20px">
          <el-col :span="24" style="text-align: center">
            <el-button type="primary" @click="editTechnology">确 定</el-button>
            <el-button @click="cancelAdd">返 回</el-button>
          </el-col>
        </el-row>
      </el-card>
    </el-form>
    <FileView ref="fileView" />
  </div>
</template>

<script>
import FileView from "../../components/common/FileView.vue";
import CommonUtils from "../../util/CommonUtils";
export default {
  props: {
    itemData: Object,
  },
  data() {
    return {
      paramsTemplateId: "",
      paramsTemplateList: [],
      addForm: {
        technologyCode: "",
        materialId: null,
        routeName: "",
        factoryModelNames: [],
        procedureList: [
          {
            procedureIndex: 1,
            factoryModelCode: null,
            procedureName: "",
            procedureCode: "",
            needScanCode: false,
            procedureMapFactoryModelList: [],
            procedureMaterialList: [
              //工序物料列表
              {},
            ],
            toolFixtureList: [
              //工装夹具列表
              {},
            ],
            technologyParameterList: [
              //工艺参数列表
              {},
            ],
            sopDocList: [
              //SOP文档列表
              {},
            ],
            technologyParameterInfoList: [
              //自定义参数列表
              {},
            ],
            index: 0,
          },
        ],
      },
      options: [],
      index: 0,
      activeName: "sopDocList",
      procedureList: [
        {
          procedureIndex: 1,
          factoryModelCode: null,
          procedureName: "",
          procedureCode: "",
          needScanCode: false,
          procedureMapFactoryModelList: [],
          procedureMaterialList: [
            //工序物料列表
            {},
          ],
          toolFixtureList: [
            //工装夹具列表
            {},
          ],
          technologyParameterList: [
            //工艺参数列表
            {},
          ],
          sopDocList: [
            //SOP文档列表
            {},
          ],
          technologyParameterInfoList: [
            //自定义参数列表
            {},
          ],
          index: 0,
        },
      ],
      rules: {
        technologyCode: [{ required: true, message: "请输入工艺编号", trigger: "blur" }],

        materialId: [{ required: true, message: "请选择物料编码", trigger: "blur" }],

        factoryModelCode: [
          { required: true, message: "请选择工作中心", trigger: "change" },
        ],
        procedureIndex: [
          { required: true, message: "工序号不能为空", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (value) {
                let reg = /^([1-9]{1}\d*)$/;
                if (!reg.test(value)) {
                  callback(new Error("工序号必须为正整数"));
                } else {
                  callback();
                }
              } else {
                callback("工序号不能为空");
              }
            },
            trigger: "blur",
          },
        ],
        routeName: [{ required: true, message: "请输入工艺路线名称", trigger: "blur" }],
        procedureName: [{ required: true, message: "请输入工序名称", trigger: "blur" }],
        defaultSalary: [
          {
            validator(rule, value, callback) {
              if (value) {
                let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,4})?$/;
                if (!reg.test(value)) {
                  callback(`工价大于零且最多可保留4位小数`);
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      tempId: null,
      isChange: false,
      W: true,
      loading: false,
      selectMaterial: {},
      replaceMaterialList: [],
      materialList: [],
      templateOptions: [],
      toolGroupList: [], //唯一
      deviceList: [],
      subMaterialList: [],
      selectIndex: null,
      deviceTypeOptions: [],
      factoryModelList: [],
      procedureMapFactoryModelList: [],
      permission: JSON.parse(localStorage.getItem("permission")),
    };
  },
  components: {
    FileView,
  },
  mounted: async function () {
    // await this.getFactoryModelLevel()
    this.procedureMapFactoryModelList = await this.loadProcedureListByProcedure();
    await this.getTechnologyInfoByTechnologyId(this.itemData.id);
    this.loadToolGroupList();
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
    // this.procedureMapFactoryModelList = await this.loadProcedureListByProcedure()
    this.loadDeviceTypeList();
    this.loadFactoryModelList();
    this.getTemplateList();
  },
  methods: {
    getTemplateList() {
      this.$RequestUtil.get({
        url: "/api/technology-params/list-model",
        params: {},
        success: (res) => {
          if (res.code == 0) {
            this.paramsTemplateList = res.data;
          }
        },
      });
    },
    changeParamsTemplate(id, index) {
      this.$RequestUtil.get({
        url: "/api/technology-params/model-item",
        params: {
          modelId: id,
        },
        success: (res) => {
          if (res.code == 0) {
            if (res.data.length > 0) {
              res.data.forEach((e) => {
                e.modelId = undefined;
                e.id = undefined;
              });
              this.procedureList[index].technologyParameterInfoList = res.data;
            } else {
              this.procedureList[index].technologyParameterInfoList = [{}];
            }
          }
        },
      });
    },
    async loadFactoryModelList() {
      let { data } = await this.$RequestUtil.getAsync({
        url: "/api/factoryModel/getWorkShopList",
        params: {},
      });
      this.factoryModelList = data;
    },
    async loadDeviceTypeList() {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/device/listDeviceType",

        params: {},
      });
      if (code == 0) {
        this.deviceTypeOptions = data;
      } else {
        this.$message.error(msg || message);
      }
    },
    procedureSelectChange(row) {
      let findItem =
        row.procedureMapFactoryModelList.find(
          (item) => item.procedureCode == row.procedureCode
        ) || {};
      this.$set(row, "procedureName", findItem.procedureName);
      this.$set(row, "factoryModelCode", findItem.factoryModelCode);
      this.$set(row, "factoryModelName", findItem.factoryModelName);
    },
    async loadProcedureListByProcedure(procedureCode, procedureName, row) {
      let { data, code, message, msg } = await this.$RequestUtil.getAsync({
        url: "/api/factoryModel/listByProcedureCode",
        params: { procedureCode, procedureName },
      });
      if (row) {
        if (row.procedureCode) {
          let find = data.find((item) => item.procedureCode == row.procedureCode);
          if (!find) {
            data.unshift({
              procedureCode: row.procedureCode,
              procedureName: row.procedureName,
            });
          }
        }
        this.$set(row, "procedureMapFactoryModelList", data);
      }
      return data;
    },
    async loadProcedureListByWorkCenterCode(workCenterCode) {
      let { data, code, message, msg } = await this.$RequestUtil.getAsync({
        url: "/api/procedureConfig/getProcedureNameByWorkCenterCode",
        params: { workCenterCode },
      });
      return data;
    },
    getTechnologyInfoByTechnologyId: async function (id) {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/technology/getTechnology",
        type: "sync",
        params: { id },
      });
      this.addForm = data;
      this.addForm.id = this.itemData.id;
      if (data.procedureList.length == 0) {
        let json = {
          procedureIndex: 1,
          factoryModelCode: null,
          procedureName: "",
          procedureCode: "",
          needScanCode: false,
          procedureMapFactoryModelList: CommonUtils.cloneObj(
            this.procedureMapFactoryModelList
          ),
          procedureMaterialList: [
            //工序物料列表
            {},
          ],
          toolFixtureList: [
            //工装夹具列表
            {},
          ],
          technologyParameterList: [
            //工艺参数列表
            {},
          ],
          sopDocList: [
            //SOP文档列表
            {},
          ],
          technologyParameterInfoList: [
            //自定义参数列表
            {},
          ],
          index: 0,
        };
        data.procedureList.push(json);
      } else {
        data.procedureList.forEach(async (item, index) => {
          if (item.procedureMaterialList.length == 0) {
            item.procedureMaterialList.push({});
          }
          if (item.toolFixtureList.length == 0) {
            item.toolFixtureList.push({});
          }
          if (item.technologyParameterList.length == 0) {
            item.technologyParameterList.push({});
          }
          if (item.sopDocList.length == 0) {
            item.sopDocList.push({});
          } else {
            item.sopDocList.forEach((s) => {
              if (s.fileName) {
                s.filePath = this.getFilePath(s.fileName);
                s.fileUrl = s.url;
              }
            });
          }

          if (
            item.technologyParameterInfoList &&
            item.technologyParameterInfoList.length == 0
          ) {
            item.technologyParameterInfoList.push({});
          }

          item.procedureNameList = [];
          let find = this.procedureMapFactoryModelList.find(
            (f) => f.procedureCode == item.procedureCode
          );
          if (!find) {
            let temp = CommonUtils.cloneObj(this.procedureMapFactoryModelList);
            temp.unshift({
              procedureCode: item.procedureCode,
              procedureName: item.procedureName,
            });
            this.$set(item, "procedureMapFactoryModelList", temp);
          } else {
            this.$set(
              item,
              "procedureMapFactoryModelList",
              CommonUtils.cloneObj(this.procedureMapFactoryModelList)
            );
          }
          item.index = index;
        });
        if (data.procedureList[0].factoryModelCode) {
          this.loadDeviceList(data.procedureList[0].factoryModelCode);
        }
      }

      let temp = data.procedureList[0].procedureMaterialList[0] || {};
      this.materialList = await this.loadMaterialList(
        "",
        "",
        data.type,
        "",
        data.materialId
      );
      let find = this.materialList.find((m) => m.id == data.materialId);
      if (!find) {
        this.materialList.push({
          id: data.materialId,
          itemType: data.type,
          materialCode: data.materialCode,
          materialName: data.materialName,
        });
      }

      this.loadSubMaterialList(data.materialId);

      this.replaceMaterialList = await this.loadMaterialList(
        temp.replaceMaterialName,
        "",
        -1
      );
      this.procedureList = data.procedureList;

      if (data.factoryModelNames) {
        this.addForm.factoryModelNames = data.factoryModelNames.split(",");
      }
      this.$set(this.addForm, "procedureList", data.procedureList);
    },

    itemChange(ev) {
      log(ev);
    },

    handdle(row, column, event) {
      if (row.index < this.procedureList.length) {
        this.index = row.index;
      } else {
        this.index = 0;
      }
      this.paramsTemplateId = "";
      if (this.procedureList[this.index].factoryModelCode) {
        this.loadDeviceList(this.procedureList[this.index].factoryModelCode);
      }
    },

    rowClass({ row, columnIndex }) {
      if (row.index == this.index) {
        return "select-row";
      } else {
        return "";
      }
    },
    rowStyle({ row, columnIndex }) {
      if (row.index == this.index) {
        return { "background-color": "rgb(109, 183, 238)", cursor: "pointer" };
      } else {
        return { cursor: "pointer" };
      }
    },

    //通过模板查询工序数据
    async getProcedureByTemplateId(technologyTemplateId) {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/technologyTemplate/getTemplateMsg",
        type: "sync",
        params: { technologyTemplateId },
      });
      if (code == 0) {
        return data;
      } else {
        this.$message.error(msg || message);
      }
    },

    templateFocus(ev) {
      if (ev && !this.isChange) {
        this.tempId = this.addForm.templateId;
      }
    },
    async templateChange(ev) {
      this.isChange = true;
      if (!ev) {
        return;
      }
      let data = await this.getProcedureByTemplateId(ev);
      if (this.addForm.procedureList.length > 0) {
        let {
          procedureCode,
          factoryModelCode,
          procedureName,
          defaultSalary,
          needScanCode,
        } = this.addForm.procedureList[0];
        if (
          this.addForm.procedureList.length == 1 &&
          !procedureCode &&
          !factoryModelCode &&
          !procedureName &&
          !defaultSalary &&
          !needScanCode
        ) {
          this.changeProcedureData(data);
          this.isChange = false;
        } else {
          this.$confirm("此操作将删除现有工序数据, 是否继续?", "提示", {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(
            () => {
              this.$refs.mySelect.handleClose();
              this.changeProcedureData(data);
              this.isChange = false;
            },
            (err) => {
              this.$set(this.addForm, "templateId", this.tempId);
              this.$refs.mySelect.handleClose();
              this.isChange = false;
            }
          );
        }
      } else {
        this.changeProcedureData(data);
        this.isChange = false;
      }
    },

    async changeProcedureData(data) {
      if (data.templateFlowDtos.length == 0) {
        return;
      }
      data.templateFlowDtos.forEach((item, index) => {
        item.procedureMaterialList = [{}];
        item.toolFixtureList = [{}];
        item.technologyParameterList = [{}];
        item.sopDocList = [{}];
        item.technologyParameterInfoList = [{}];
        item.index = index;
        item.procedureMapFactoryModelList = CommonUtils.cloneObj(
          this.procedureMapFactoryModelList
        );
        item.procedureIndex = index + 1;
      });
      this.addForm.procedureList = data.templateFlowDtos;
      this.procedureList = data.templateFlowDtos;
      if (this.procedureList[0] && this.procedureList[0].factoryModelCode) {
        await this.loadDeviceList(this.procedureList[0].factoryModelCode);
      }
    },

    async selectFactoryModel(ev, scope) {
      let procedureNameList = await this.loadProcedureListByWorkCenterCode(ev);
      this.$set(scope.row, "procedureNameList", procedureNameList);
      if (!scope.row.procedureName) {
        let procedureName = "";
        this.options.forEach((item) => {
          item.children.forEach((sub) => {
            sub.children.forEach((l3) => {
              if (l3.factoryCode == ev) {
                procedureName = l3.factoryName;
              }
            });
          });
        });
        this.$set(scope.row, "procedureName", procedureName);
      }
      await this.loadDeviceList(ev);
    },

    materialSelect() {
      this.selectMaterial = this.materialList.find(
        (item) => item.id == this.addForm.materialId
      );
      this.$set(this.addForm, "type", (this.selectMaterial || {}).itemType);
      this.loadSubMaterialList(this.addForm.materialId);
    },

    subMaterialSelect(ev, scope, type) {
      if (type == 0) {
        this.$set(
          scope.row,
          "itemType",
          (this.subMaterialList.find((item) => item.id == scope.row.materialId) || {})
            .itemType
        );
      } else {
        this.$set(scope.row, "materialId", null);
      }
    },

    async typeSelect() {
      this.$set(this.addForm, "materialId", null);
      this.materialList = await this.loadMaterialList();
    },

    async loadDeviceList(factoryModelCode) {
      let { data, msg, code, message } = await this.$RequestUtil.getAsync({
        url: "/api/device/getDeviceListByFactoryModelId",
        params: { factoryModelCode },
      });
      if (code == 0) {
        this.deviceList = data;
      } else {
        this.$message.error(msg || message);
      }
    },

    addLists(index) {
      let len = this.procedureList.length;
      let lastIndex = Number(this.procedureList[len - 1].procedureIndex) + 1;
      let json = {
        procedureIndex: lastIndex,
        factoryModelCode: "",
        factoryModelName: "",
        procedureName: "",
        procedureCode: "",
        procedureMaterialList: [{}],
        toolFixtureList: [{}],
        technologyParameterList: [{}],
        sopDocList: [{}],
        technologyParameterInfoList: [{}],
        index: len,
        isNeedReport: true,
        procedureMapFactoryModelList: CommonUtils.cloneObj(
          this.procedureMapFactoryModelList
        ),
      };
      this.procedureList.splice(index + 1, 0, json);
      for (let i = index + 1; i < this.procedureList.length; i++) {
        let item = this.procedureList[i];
        let next = this.procedureList[i + 1];
        if (next) {
          item.procedureIndex = next.procedureIndex;
        } else {
          item.procedureIndex = lastIndex;
        }
      }
      return false;
    },

    downLists(index) {
      let temp = CommonUtils.cloneObj(this.procedureList[index + 1]);
      this.$set(
        this.procedureList,
        index + 1,
        CommonUtils.cloneObj(this.procedureList[index])
      );
      this.$set(this.procedureList, index, temp);
      let nowIndex = temp.procedureIndex;
      this.procedureList[index].procedureIndex = this.procedureList[
        index + 1
      ].procedureIndex;
      this.procedureList[index + 1].procedureIndex = nowIndex;
      return false;
    },

    topLists(index) {
      let temp = CommonUtils.cloneObj(this.procedureList[index - 1]);
      this.$set(
        this.procedureList,
        index - 1,
        CommonUtils.cloneObj(this.procedureList[index])
      );
      this.$set(this.procedureList, index, temp);
      let nowIndex = temp.procedureIndex;
      this.procedureList[index].procedureIndex = this.procedureList[
        index - 1
      ].procedureIndex;
      this.procedureList[index - 1].procedureIndex = nowIndex;
      return false;
    },

    delLists(index) {
      this.procedureList.splice(index, 1);
      this.procedureList.forEach((item, i) => {
        item.index = i;
      });
      return false;
    },

    // 获取物料名称下拉选项
    async loadMaterialList(
      materialName,
      materialCode,
      itemType,
      specification,
      materialId,
      webSearchStr
    ) {
      let type = null;
      if (itemType == -1) {
        type = null;
      } else {
        type = this.addForm.type;
      }
      let res = await this.$RequestUtil.getAsync({
        url: "/api/select/listMaterial",
        params: {
          isTechnology: true,
          materialName,
          materialCode,
          itemType: type,
          specification,
          materialId,
          webSearchStr,
        },
      });
      if (res.code != 0) {
        this.$message.error(res.msg || res.message);
        return;
      }
      return res.data;
    },
    async remoteMethod(materialName, materialCode, itemType, specification) {
      this.loading = true;
      this.materialList = await this.loadMaterialList(
        materialName,
        materialCode,
        itemType,
        specification
      );
      this.loading = false;
    },
    async materialSelectClose(ev) {
      if (!ev) {
        this.materialList = await this.loadMaterialList("", "", this.addForm.type);
        if (this.addForm.materialId) {
          if (
            !this.materialList.map((item) => item.id).includes(this.addForm.materialId)
          ) {
            if (this.addForm.materialId == this.selectMaterial.id) {
              this.materialList.push(this.selectMaterial);
            }
          }
        }
      }
    },
    async replaceMaterialClose(ev) {
      if (!ev) {
        this.replaceMaterialList = await this.loadMaterialList();
      }
    },
    async remoteMethodReplace(query) {
      this.loading = true;
      this.replaceMaterialList = await this.loadMaterialList(
        null,
        null,
        -1,
        null,
        null,
        query
      );
      this.loading = false;
    },
    //加载物料下的子物料
    async loadSubMaterialList(id) {
      let { data, msg, code, message } = await this.$RequestUtil.getAsync({
        url: "/api/material/getNextBomMaterialList",
        params: { id },
      });
      if (code == 0) {
        if (data[0] == null) {
          this.subMaterialList = [];
        } else {
          this.subMaterialList = data;
        }
      } else {
        this.$message.error(msg || message);
      }
    },

    // 获取工作中心下拉选项
    async getFactoryModelLevel(Name, Code) {
      let res = await this.$RequestUtil.getAsync({
        url: "/api/factoryModel/listFactoryMultilevel",
        params: { Name, Code },
      });
      if (res.code != 0) {
        this.$message.error(res.msg || res.message);
        return;
      }
      this.options = res.data;
    },
    async loadToolGroupList() {
      let { data, msg, code, message } = await this.$RequestUtil.getAsync({
        url: "/api/toolGroup/getList",
        params: {},
      });
      if (code == 0) {
        this.toolGroupList = data;
      } else {
        this.$message.error(msg || message);
      }
    },
    checkNum(num, name, type, maxNum = 2) {
      //校验保留两位小数 如果错误返回错误原因
      let res = {
        isPass: true,
        errTxt: "",
      };
      num = Number(num);
      if (isNaN(num)) {
        res.isPass = false;
        res.errTxt = name + "必须为数字";
        return res;
      }
      if (num <= 0) {
        res.isPass = false;
        res.errTxt = name + "必须大于零";
        return res;
      }
      if (num.toFixed(maxNum) != num) {
        res.isPass = false;
        res.errTxt = name + `最多可保留${maxNum}位小数`;
        return res;
      }
      if (type == 1) {
        if (num > 100) {
          res.isPass = false;
          res.errTxt = name + "不能大于100";
          return res;
        }
      }
      return res;
    },
    // 编辑BOM
    editTechnology(index) {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          this.addForm.procedureList = this.procedureList;
          let procedureIndexList = [
            ...new Set(this.procedureList.map((item) => Number(item.procedureIndex))),
          ];
          if (procedureIndexList.length < this.procedureList.length) {
            this.$message.error("工序号不可重复");
            return;
          }
          let params = CommonUtils.cloneObj(this.addForm);
          let allPass = true;
          for (let i = 0; i < params.procedureList.length; i++) {
            let item = params.procedureList[i];
            item.procedureMaterialList = item.procedureMaterialList.filter(
              (sub) => !CommonUtils.isEmptyObject(sub)
            );
            item.toolFixtureList = item.toolFixtureList.filter(
              (sub) => !CommonUtils.isEmptyObject(sub)
            );
            item.technologyParameterList = item.technologyParameterList.filter(
              (sub) => !CommonUtils.isEmptyObject(sub)
            );
            item.sopDocList = item.sopDocList.filter(
              (sub) => !CommonUtils.isEmptyObject(sub)
            );
            item.technologyParameterInfoList = item.technologyParameterInfoList.filter(
              (sub) => !CommonUtils.isEmptyObject(sub)
            );
            let isCheck = true;
            let title = "";
            for (let j = 0; j < item.procedureMaterialList.length; j++) {
              let sub = item.procedureMaterialList[j];
              if (sub.yield) {
                let { isPass, errTxt } = this.checkNum(
                  sub.yield,
                  `第${i + 1}道工序第${j + 1}条工序物料成材率`,
                  1
                );
                if (!isPass) {
                  isCheck = isPass;
                  title = errTxt;
                  break;
                }
              }
            }
            if (!isCheck) {
              allPass = false;
              this.$message.error(title);
              break;
            }
            for (let j = 0; j < item.technologyParameterList.length; j++) {
              let sub = item.technologyParameterList[j];
              if (sub.minBatch) {
                let { isPass, errTxt } = this.checkNum(
                  sub.minBatch,
                  `第${i + 1}道工序第${j + 1}条工艺参数最小转移批量`
                );
                if (!isPass) {
                  isCheck = isPass;
                  title = errTxt;
                  break;
                }
              }
              if (sub.productionCycle) {
                let { isPass, errTxt } = this.checkNum(
                  sub.productionCycle,
                  `第${i + 1}道工序第${j + 1}条工艺参数节拍`
                );
                if (!isPass) {
                  isCheck = isPass;
                  title = errTxt;
                  break;
                }
              }
              if (sub.standardCapacity) {
                let { isPass, errTxt } = this.checkNum(
                  sub.standardCapacity,
                  `第${i + 1}道工序第${j + 1}条工艺参数日标准产能`
                );
                if (!isPass) {
                  isCheck = isPass;
                  title = errTxt;
                  break;
                }
              }
              if (sub.prepareTime) {
                let { isPass, errTxt } = this.checkNum(
                  sub.prepareTime,
                  `第${i + 1}道工序第${j + 1}条工艺参数前置时间`
                );
                if (!isPass) {
                  isCheck = isPass;
                  title = errTxt;
                  break;
                }
              }
              if (sub.everySalary) {
                let { isPass, errTxt } = this.checkNum(
                  sub.everySalary,
                  `第${i + 1}道工序第${j + 1}条工艺参数工价`,
                  "",
                  4
                );
                if (!isPass) {
                  isCheck = isPass;
                  title = errTxt;
                  break;
                }
              }
            }
            // 自定义参数
            for (let j = 0; j < item.technologyParameterInfoList.length; j++) {
              let sub = item.technologyParameterInfoList[j];
              if (sub.lowerLimit) {
                let { isPass, errTxt } = this.checkNum(
                  sub.lowerLimit,
                  `第${i + 1}道工序第${j + 1}条自定义参数下限值`,
                  0,
                  4
                );
                if (!isPass) {
                  isCheck = isPass;
                  title = errTxt;
                  break;
                }
              }
              if (sub.upperLimit) {
                let { isPass, errTxt } = this.checkNum(
                  sub.upperLimit,
                  `第${i + 1}道工序第${j + 1}条自定义参数上限值`,
                  0,
                  4
                );
                if (!isPass) {
                  isCheck = isPass;
                  title = errTxt;
                  break;
                }
              }
            }
            if (!isCheck) {
              allPass = false;
              this.$message.error(title);
              break;
            }
          }
          if (!allPass) {
            return;
          }
          if (params.factoryModelNames) {
            params.factoryModelNames = params.factoryModelNames.join(",");
          }
          this.$RequestUtil.post({
            url: "/api/technology/updateTechnology",
            type: "sync",
            params,
            success: (res) => {
              if (res.code == 0) {
                this.$message.success("修改成功");
                this.cancelAdd();
              } else {
                this.$message.error(res.msg || res.message);
              }
            },
          });
        }
      });
    },

    cancelAdd() {
      this.$parent.initTable();
      this.$parent.showPage = 1;
    },

    // 删除
    delProLists(index) {
      this.procedureList[this.index].procedureMaterialList.splice(index, 1);
    },

    // 添加
    addProLists(index) {
      this.procedureList[this.index].procedureMaterialList.push({});
    },

    // 删除
    delTooLists(index) {
      this.procedureList[this.index].toolFixtureList.splice(index, 1);
    },
    // 添加
    addTooLists(index) {
      this.procedureList[this.index].toolFixtureList.push({});
    },
    // 删除
    delTecLists(index) {
      this.procedureList[this.index].technologyParameterList.splice(index, 1);
    },
    // 添加
    addTecLists(index) {
      this.procedureList[this.index].technologyParameterList.push({});
    },
    // SOP删除
    delSopLists(index) {
      this.procedureList[this.index].sopDocList.splice(index, 1);
    },
    // SOP添加
    addSopLists(index) {
      this.procedureList[this.index].sopDocList.push({});
    },
    addParameterList() {
      this.procedureList[this.index].technologyParameterInfoList.push({});
    },
    delParameterList(index) {
      this.procedureList[this.index].technologyParameterInfoList.splice(index, 1);
    },
    // 获取数量
    getProNumInput(ev, index) {
      this.procedureMaterialList[index].amount = ev;
    },
    // 选择SOP文件
    selectUploadFile: function (scope, fileType) {
      if (!this.permission.btn_fileSys_list) {
        this.$message.warning("您暂无文件管理权限");
        return;
      }
      this.$refs.fileView.initView(null, fileType);
      this.selectIndex = scope.$index;
    },
    uploadComplete(res) {
      log(res, 5555);
      if (res.data) {
        this.$set(
          this.procedureList[this.index].sopDocList[this.selectIndex],
          "fileId",
          res.data.id
        );
        this.$set(
          this.procedureList[this.index].sopDocList[this.selectIndex],
          "fileName",
          res.data.fileName
        );
        this.$set(
          this.procedureList[this.index].sopDocList[this.selectIndex],
          "fileUrl",
          res.data.url
        );
        this.$set(
          this.procedureList[this.index].sopDocList[this.selectIndex],
          "filePath",
          this.getFilePath(res.data.fileName)
        );
      }
    },
    showFile: function (url) {
      if (!this.permission.btn_file_get) {
        this.$message({
          type: "error",
          message: `抱歉，您暂无文件读取权限`,
        });
        return false;
      }
      if (!url) {
        this.$message.warning("当前文件不存在");
        return;
      }
      let index = url.lastIndexOf(".");
      let ext = url.substr(index + 1).toLowerCase();
      //可直接被浏览器打开的文件类型
      let arr = [
        "pdf",
        "png",
        "jpg",
        "svg",
        "txt",
        "html",
        "js",
        "art",
        "au",
        "aiff",
        "xbf",
        "jpeg",
      ];
      if (arr.includes(ext)) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    },
    deleteFile: function (scope, type) {
      if (!this.permission.btn_file_upload) {
        this.$message({
          type: "error",
          message: `抱歉，您暂无文件删除权限`,
        });
        return false;
      }
      this.$confirm("此操作将删除该文件, 是否继续?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$set(scope.row, "fileName", "");
        this.$set(scope.row, "fileId", null);
        this.$set(scope.row, "fileUrl", "");
        this.$set(scope.row, "filePath", "");
      });
    },
    getFilePath(fileName) {
      if (!fileName) {
        return;
      }
      let filePath = "";
      let arr = fileName.split(".");
      let suffix = arr[arr.length - 1];

      switch (true) {
        case suffix == "pdf" || suffix == "pptx":
          filePath = "../../../static/img/pdf.png";
          break;
        case suffix == "png" || suffix == "jpg" || suffix == "svg":
          filePath = "../../../static/img/pic.png";
          break;
        case suffix == "txt" || suffix == "doc" || suffix == "docx":
          filePath = "../../../static/img/txt.png";
          break;
        default:
          filePath = "../../../static/img/file.png";
      }
      return filePath;
    },
  },
};
</script>

<style scoped>
.eltabs {
  margin-top: 20px;
}
.file-icon-container {
  width: 36px;
  height: 45px;
  margin-top: 0px;

  background-size: cover;
  position: relative;
  cursor: pointer;
}

.file-delete {
  position: absolute;
  top: -6px;
  left: 28px;
  width: 15px;
  height: 15px;
  background-image: URL("../../../static/img/delete.png");
  background-size: cover;
  cursor: pointer;
}
@media screen and (max-width: 1440px) {
  .add-technologyBom {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}
.add-technologyBom .title {
  font-size: 14px;
}
</style>
<style>
.add-technologyBom .el-table--enable-row-hover .el-table__body .select-row:hover > td {
  background-color: rgb(109, 183, 238);
}
.add-technologyBom .el-form-item--mini.el-form-item,
.add-technologyBom .el-form-item--small.el-form-item {
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/TechnologyBOM/EditTechnology.vue